import React from "react";
import { Link } from "react-router-dom";
import LegalDocumentTopBack from "./LegalDocumentTopBack";
import SiteFooter from "../components/SiteFooter";
import { useTranslation } from "../i18n/useTranslation";

const CONTACT_EMAIL =
  process.env.REACT_APP_ACCESSIBILITY_CONTACT_EMAIL || "support@mysipur.app";

const AccessibilityStatement: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="relative min-h-screen flex flex-col bg-brandBeige">
      <main
        id="main-content"
        tabIndex={-1}
        className="relative z-10 mx-auto w-full max-w-2xl flex-1 px-4 py-10"
      >
        <LegalDocumentTopBack />
        <h1 className="text-3xl font-extrabold text-heading mb-6">{t("a11y.statement.title")}</h1>

        <section className="mb-8 space-y-3 text-body leading-relaxed">
          <p>{t("a11y.statement.intro")}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-heading mb-2">{t("a11y.statement.conformanceTitle")}</h2>
          <p className="text-body leading-relaxed">{t("a11y.statement.conformanceBody")}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-heading mb-2">{t("a11y.statement.languagesTitle")}</h2>
          <p className="text-body leading-relaxed">{t("a11y.statement.languagesBody")}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-heading mb-2">{t("a11y.statement.limitationsTitle")}</h2>
          <p className="text-body leading-relaxed">{t("a11y.statement.limitationsBody")}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-heading mb-2">{t("a11y.statement.contactTitle")}</h2>
          <p className="text-body leading-relaxed mb-3">{t("a11y.statement.contactBody")}</p>
          <p>
            <a
              className="font-semibold text-brandNavy underline underline-offset-2 hover:text-brandOrange focus:outline-none focus:ring-2 focus:ring-brandOrange rounded"
              href={`mailto:${CONTACT_EMAIL}?subject=Accessibility`}
            >
              {CONTACT_EMAIL}
            </a>
          </p>
        </section>

        <p className="mb-8">
          <Link
            to="/"
            className="font-semibold text-brandNavy hover:underline focus:outline-none focus:ring-2 focus:ring-brandOrange rounded"
          >
            ← {t("orderSummary.backHome")}
          </Link>
        </p>
      </main>
      <SiteFooter />
    </div>
  );
};

export default AccessibilityStatement;
